module.exports = __webpack_public_path__ + "img/phone.ffc85a35.svg";